import { render, staticRenderFns } from "./OperaSitesWindow.vue?vue&type=template&id=0704df53&"
import script from "./OperaSitesWindow.vue?vue&type=script&lang=js&"
export * from "./OperaSitesWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports